import axios from '@axios'

export default {
  submitEmail(params) {
    return axios.post('/api/partnership/join-letter', params)
  },
}
